import {
  getDocs,
  getDoc,
  query,
  collectionGroup,
  doc,
} from 'firebase/firestore'
import logger from '@common/src/lib/logger'
import { db } from '../../firebase/firebaseapi'
import { COLLECTIONS } from '../../constants/constants'
import { currentRegion } from '@common/src/config/regions'

export const getStore = async (all, ids) => {
  try {
    let snap
    let docs

    if (all) {
      const storesQuery = query(collectionGroup(db, COLLECTIONS.STORES));
      snap = await getDocs(storesQuery)
      docs = snap.docs;

    } else if (ids && Array.isArray(ids) && ids.length > 0) {
      const storesQuery = query(collectionGroup(db, COLLECTIONS.STORES));
      // const storesQuery = query(collectionGroup(db, COLLECTIONS.STORES), where(documentId(), 'in', ids) );
      snap = await getDocs(storesQuery)
      docs = snap.docs
        .filter((doc) => ids.includes(doc.id))

    } else {
      logger.warn('No valid ids provided for filtering.')
      return [] // Return an empty array if no valid ids are provided
    }

    // Map the documents to the desired format
    const data = await Promise.all(
      docs.map(async (item) => {
        const companyId = item.ref.path.split("/")[1]; // Extract companyId

        // Fetch company document
        const companyRef = doc(db, COLLECTIONS.COMPANIES, companyId);
        const snap = await getDoc(companyRef);
        const company = snap.data();
        return {
          value: parseInt(item.id),
          label: `${item.data()?.name?.en} , ${item.data()?.address?.city?.en}`,
          companyId,
          outletCode: item.data()?.outletCode,
          country: company?.config?.country?.countryCode || company?.country?.countryCode || currentRegion.defaultCountryCode,
        };
      })
    );

    return data
  } catch (error) {
    logger.error('Error fetching Store data:', error)
    return [] // Return an empty array in case of error
  }
}
